import React from 'react';
import {useStyles} from "./styles"
import {ReactComponent as InfoCircleIcon} from "../../../assets/images/icon-info-circle.svg"
export interface IInfoCard{
  title:string;
  content:React.ReactNode;
}
export function InfoCard({title,content}:IInfoCard) {
  const classes = useStyles();
  return (
    <div className={classes.InfoCard} data-component-name="REFUND_NOTIFICATION">
      <header>
        <InfoCircleIcon/>
        <p>{title}</p>
      </header>
      <p>{content}</p>
    </div>
  )
}
